(function ($) {
    $.nette.ext('column-select', {
        init() {
            const self = this;

            this.ext('snippets', true).after($.proxy(($el) => {
                const $items = $el.find('.col-action select');
                if ($items.length <= 0) {
                    return;
                }

                for (let i = 0; i < $items.length; i++) {
                    self.abc($($items[i]));
                }
            }, this));

            $('.col-action select').each(function () {
                self.abc($(this));
            });
        },
    }, {
        abc($el) {
            $el.on('change', function () {
                const link = $(this).data('href');
                const key = $(this).data('key');
                const value = $(this).val();

                $.nette.ajax({
                    type: 'GET',
                    url: `${link}&${key}=${value}`,
                });
            });
        },
    });
}(jQuery));
